const MessageIcon = () => (
    <svg 
        viewBox="0 0 24 24" 
        style={{ 
            display: "flex", 
            color: "rgb(58, 62, 82)", 
            fill: "currentColor", 
            height: "40px", 
            width: "40px", 
            userSelect: "none", 
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
        }}
    >
        <circle cx="12" cy="12" r="12" fill="#F5A623" />
        <path 
            fill="white" 
            d="M6.9 15.3c.5.5 2.1 1.5-.2 3 1 .3 2.4 0 3.5-.9.4-.3 1.3-.2 1.8-.2 3.8 0 6.9-2.5 6.9-5.5S15.8 6.2 12 6.2s-6.9 2.5-6.9 5.5c.1 1.4.7 2.6 1.8 3.6z"
        />
    </svg>
);

export default MessageIcon;
